import { useTranslation } from 'react-i18next';

import { ReactComponent as UploadIcon } from '../../../../../../../../assets/icons/icon-download.svg';
import CustomButton from '../../../../../../../../shared/components/Buttons/CustomButton/CustomButton';
import { TRANSLATIONS_QUOTES } from '../../../../../../../../shared/translations/quotes';

interface ICensusUploadTriggerProps {
  onOpen: () => void;
}

export default function CensusUploadTrigger({ onOpen }: Readonly<ICensusUploadTriggerProps>) {
  const { t } = useTranslation();

  return (
    <CustomButton variant="default" size="s" onClick={onOpen} className="quote-product-row__upload-btn">
      <UploadIcon className="quote-product-row__upload-icon" />
      {t(TRANSLATIONS_QUOTES.create.row.uploadQuickCensusBtn)}
    </CustomButton>
  );
}
